import { render } from "./AssetAllocationChart.vue?vue&type=template&id=141a1f5d&ts=true"
import script from "./AssetAllocationChart.vue?vue&type=script&lang=ts"
export * from "./AssetAllocationChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__